import React from "react";
import CardWrapper from "../layouts/CardWrapper";
import Image from "react-bootstrap/Image";
import PageTitle from "../components/PageTitle";

const NotFound = () => {
  return (
    <>
      <PageTitle className="mb-4" title="Not Found" />
      <CardWrapper className="full-box-0 d-flex flex-column align-items-center justify-content-center">
        <Image src="/images/page-not-found.svg" />
      </CardWrapper>
    </>
  );
};

export default NotFound;
